export default "<div>\n    {{ startDate }} {{'at' | translate}} {{ startTime }}\n</div>\n";